import React, { useState, useEffect, useCallback } from "react";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Header from "../../components/Header";
import Section from "../../components/Section";
import SuccessNotification from "../../components/Notifications/SuccessNotification";
import ErrorNotification from "../../components/Notifications/ErrorNotification";
import LoginNotification from "../../components/Notifications/LoginNotification";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faSave,
    faRotate,
    faCircleArrowLeft,
    faXmark
} from "@fortawesome/free-solid-svg-icons";
import apiClient from "../../axios";
import Loader from "../../components/Loader";

const CompaniesForm = ({ handleLogout }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { id } = useParams();
    const { numCont } = location.state || {};
    const [loading, setLoading] = useState(false);
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [ruc, setRuc] = useState("");
    const [contract, setContract] = useState("");
    const [contractSearch, setContractSearch] = useState("");
    const [contractData, setContractData] = useState([]);
    const [isContractSelected, setIsContractSelected] = useState(false);
    const [sequence, setSequence] = useState("");
    const [isClosed, setIsClosed] = useState(false);
    const [isSuccessVisible, setIsSuccessVisible] = useState(false);
    const [isErrorVisible, setIsErrorVisible] = useState(false);
    const [errorsMessage, setErrorMessage] = useState({});
    const [isLoginVisible, setIsLoginVisible] = useState(false);
    const [errors, setErrors] = useState({});
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const contract2 = process.env.REACT_APP_FENIX_CONTRACT;
    const [engine, setEngine] = useState("");
    const [dbName, setDbName] = useState("");
    const [dbPass, setDbPass] = useState("");
    const [dbHost, setDbHost] = useState("");
    const [dbPort, setDbPort] = useState(0);
    const [dbUser, setDbUser] = useState("");
    const [uriApiFnx, setUriApiFnx] = useState("");

    useEffect(() => {
        if (id) {
            const fetchCompanie = async () => {
                try {
                    setLoading(true);
                    const response = await apiClient.get(`/admin/companies/${id}`);
                    setName(response.data.nombre);
                    setDescription(response.data.descripcion);
                    setRuc(response.data.ruc);
                    setSequence(response.data.sequence);
                    setContract(response.data.contrato);
                    setContractData(response.data.contrato);
                    setContractSearch(response.data.contrato);
                    setIsContractSelected(true);
                    setEngine(response.data.dbEngine);
                    setDbName(response.data.dbName);
                    setDbPass(response.data.dbPassword);
                    setDbHost(response.data.dbHost);
                    setDbPort(response.data.dbPort);
                    setDbUser(response.data.dbUser);
                    setUriApiFnx(response.data.uriApiFnx);
                    setIsClosed(response.data.isClosed === 1 ? true : false || false);
                } catch (error) {
                    console.error("Error al cargar la Compania", error);
                } finally {
                    setLoading(false);
                }
            };
            fetchCompanie();
        }

    }, [id, numCont]);


    const toggleSwitch = () => {
        setIsClosed((prev) => !prev);
    };

    //BUSCAR CONTRATO
    const handleSearchContract = useCallback(async (page = 1) => {
        try {
            const params = new URLSearchParams();
            if (contractSearch) params.append('search', contractSearch);

            const response = await apiClient.get(`/contracts?${params.toString()}&page=${page}`);

            if (Array.isArray(response.data.results)) {
                setContractData(response.data.results);
            } else {
                setContractData([response.data.results]);
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                setIsLoginVisible(true);
            }
        }
    }, [contractSearch]);

    useEffect(() => {
        if (!isContractSelected) {
            const delayDebounceFn = setTimeout(() => {
                if (contractSearch) {
                    handleSearchContract();
                }
            }, 200);

            return () => clearTimeout(delayDebounceFn);
        }
    }, [contractSearch, handleSearchContract, isContractSelected]);

    const handleInputChangeContract = (e) => {
        const value = e.target.value;
        setContractSearch(value);

        if (isContractSelected) {
            setIsContractSelected(false);
        }

        if (value.trim() === "") {
            setContractData([]);
        }
    };

    const handleContractSelect = (contractNumber, contractName) => {
        setContractSearch(contractName);
        setContract(contractNumber);
        setContractData([]);
        setIsContractSelected(true);
    };

    //Validar RUC
    const fetchAuthToken = async () => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_CIFRUC_URL}/login`,
                {
                    method: "GET",
                    headers: {
                        Authorization: "Basic " + btoa("fenix:7&m$T8v_12d6?aA}yVOF"),
                    },
                }
            );

            if (!response.ok) {
                throw new Error("Error al obtener el token");
            }

            const data = await response.json();
            return data.token;
        } catch (error) {
            console.error("Error al obtener el token:", error);
            return null;
        }
    };
    // Nueva función para manejar la búsqueda
    const handleDocumentSearch = async (event) => {
        if (event.key === "Enter" || event.key === "Tab") {
            event.preventDefault();
            try {
                // Obtén el token primero
                setLoading(true);
                const token = await fetchAuthToken();
                if (!token) {
                    throw new Error("No se pudo obtener el token de autenticación");
                }

                const response = await fetch(
                    `${process.env.REACT_APP_CIFRUC_URL}/document/search`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                        },
                        body: JSON.stringify({
                            contract: contract2,
                            document: ruc,
                        }),
                    }
                );

                if (!response.ok) {
                    throw new Error("Error en la búsqueda del documento");
                }
                const data = await response.json();

                if (data.document && data.document.socialReason) {
                    setIsErrorVisible(false);
                    setIsButtonDisabled(false);
                    setName(data.document.socialReason);
                } else if (data.document.establishments && data.document.establishments.length > 0) {
                    setName(data.document.establishments[0].comercialName);
                }
            } catch (error) {
                if (error.response?.data?.message.startsWith("DOCUMENT_INVALID")) {
                    setErrorMessage(
                        "El Documento de Identificación ingresado es Incorrecto o No Existe."
                    );
                    setIsErrorVisible(true);
                    setIsButtonDisabled(true);
                }
                else {
                    setErrorMessage(
                        "El Documento de Identificación ingresado es Incorrecto o No Existe."
                    );
                    setIsErrorVisible(true);
                    setIsButtonDisabled(true);
                }

                setName("");
            } finally {
                setLoading(false);
            }
        }
    };

    const handleCifChange = (e) => {
        const value = e.target.value;
        setRuc(value);

        if (value === "") {
            setName("");

        }
    };
    const validateFields = () => {
        let validationErrors = {};
        if (!name) validationErrors.name = "El Campo es Obligatorio";
        if (!description) validationErrors.description = "El Campo es Obligatorio";
        if (!ruc) validationErrors.ruc = "El Campo es Obligatorio";
        if (engine === "mysql" || engine === "vfp") {
            if (!uriApiFnx) validationErrors.uriApiFnx = "El Campo es Obligatorio";
        }
        if (engine === "mysql") {
            if (!dbName) validationErrors.dbName = "El Campo es Obligatorio";
            if (!dbHost) validationErrors.dbHost = "El Campo es Obligatorio";
            if (!dbPort) validationErrors.dbPort = "El Campo es Obligatorio";
            if (!dbUser) validationErrors.dbUser = "El Campo es Obligatorio";
            if (!dbPass) validationErrors.dbPass = "El Campo es Obligatorio";
        }
        if (engine === "vfp") {
            if (!dbName) validationErrors.dbName = "El Campo es Obligatorio";
        }
        return validationErrors;
    };

    const handleSave = async () => {
        const validationErrors = validateFields();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        try {
            let response;
            setLoading(true);
            if (numCont) {
                if (id) {
                    const payloadUpdate = {
                        name,
                        description,
                        engine,
                        dbName,
                        dbPassword: dbPass,
                        dbHost,
                        dbPort,
                        dbUser,
                        uriApiFnx
                    };
                    response = await apiClient.patch(
                        `/admin/companies/${id}`,
                        payloadUpdate
                    );
                    if (response.status === 200) {
                        setIsSuccessVisible(true);
                        setIsErrorVisible(false);
                        setIsLoginVisible(false);
                        setErrors({});
                        setTimeout(() => {
                            setIsSuccessVisible(false);
                        }, 4000);
                        navigate(-1);
                    }
                } else {
                    const payload = {
                        name,
                        description,
                        ruc,
                        sequence,
                        engine,
                        dbName,
                        dbPassword: dbPass,
                        dbHost,
                        dbPort,
                        dbUser,
                        uriApiFnx
                    };
                    response = await apiClient.post(`/contracts/${numCont}/companies`, payload);
                    if (response.status === 201) {
                        setIsSuccessVisible(true);
                        setIsErrorVisible(false);
                        setErrors({});
                        setTimeout(() => {
                            setIsSuccessVisible(false);
                        }, 4000);
                        navigate(-1);
                    }
                }
            }
            else {
                if (id) {
                    const payloadUpdate = {
                        name,
                        description,
                        engine,
                        dbName,
                        dbPassword: dbPass,
                        dbHost,
                        dbPort,
                        dbUser,
                        uriApiFnx
                    };
                    response = await apiClient.patch(
                        `admin/companies/${id}`,
                        payloadUpdate
                    );
                    if (response.status === 200) {
                        setIsSuccessVisible(true);
                        setIsErrorVisible(false);
                        setIsLoginVisible(false);
                        setErrors({});
                        setTimeout(() => {
                            setIsSuccessVisible(false);
                        }, 4000);
                        navigate(-1);
                    }
                } else {
                    const payload = {
                        name,
                        description,
                        ruc,
                        contract,
                        isClosed,
                        engine,
                        dbName,
                        dbPassword: dbPass,
                        dbHost,
                        dbPort,
                        dbUser,
                        uriApiFnx
                    };
                    response = await apiClient.post(`/admin/companies`, payload);
                    if (response.status === 201) {
                        setIsSuccessVisible(true);
                        setIsErrorVisible(false);
                        setErrors({});
                        setTimeout(() => {
                            setIsSuccessVisible(false);
                        }, 4000);
                        navigate(-1);
                    }
                }
            }

        } catch (error) {
            if (error.response && error.response.status === 401) {
                setIsLoginVisible(true);
            } else if (error.response?.data?.message.startsWith("\"ruc\" length must be at least 13 characters long")) {
                setErrorMessage("El RUC ingresado debe tener 13 digitos.");
                setIsLoginVisible(false);
                setIsErrorVisible(true);
                setIsSuccessVisible(false);
                setTimeout(() => {
                    setIsErrorVisible(false);
                }, 4000);
            } else if (error.response?.data?.message.startsWith("\"ruc\" length must be less than or equal to 13 characters long")) {
                setErrorMessage("El RUC ingresado No puede tener más de 13 digitos.");
                setIsLoginVisible(false);
                setIsErrorVisible(true);
                setIsSuccessVisible(false);
                setTimeout(() => {
                    setIsErrorVisible(false);
                }, 4000);
            }
            else {
                setErrorMessage("Oops!. Ocurrio un error al crear la Compañía.");
                setIsLoginVisible(false);
                setIsErrorVisible(true);
                setIsSuccessVisible(false);
                setTimeout(() => {
                    setIsErrorVisible(false);
                }, 4000);
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="home-container">
            <Header onLogout={handleLogout} title="Compañías" />
            <Section>
                <div className="button-return-container">
                    <FontAwesomeIcon
                        className="basic-shortcut-icon"
                        style={{ cursor: "pointer" }}
                        icon={faCircleArrowLeft}
                        onClick={(e) => {
                            e.stopPropagation();
                            navigate(-1);
                        }}
                    />
                </div>
            </Section>
            <div className="moduleNew-form-container">
                <h3 className="basic-info-form-title">Información de la Compañía</h3>
                <div className="basic-info-form-grid">
                    {!numCont && (
                        <div className="basic-info-form-group">
                            <label style={{ color: errors.contract ? "red" : "revert-layer" }}>Nro. Contrato</label>
                            <input
                                type="text"
                                placeholder="Nro. Contrato"
                                value={contractSearch}
                                onChange={handleInputChangeContract}
                                readOnly={!!id}
                            />
                            {errors.contract && <p className="error-message">{errors.contract}</p>}

                            {contractData.length > 0 && (
                                <div className="search-results2">
                                    <ul>
                                        {contractData.map((item) => (
                                            <li key={item.id} onClick={() => handleContractSelect(item.numCont, item.numCont)}>
                                                {item.numCont}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>
                    )}
                    {numCont && (
                        <div className="basic-info-form-group">
                            <label >
                                Secuencia
                            </label>
                            <input
                                type="text"
                                placeholder="Secuencia"
                                value={sequence}
                                onChange={(e) => setSequence(e.target.value)}
                                readOnly={!!id}
                            />

                        </div>
                    )}
                    <div className="basic-info-form-group">
                        <label style={{ color: errors.ruc ? "red" : "revert-layer" }}>
                            Ruc
                        </label>
                        <input
                            type="text"
                            placeholder="RUC"
                            value={ruc}
                            //onChange={(e) => setRuc(e.target.value)}
                            maxLength={13}
                            onChange={handleCifChange}
                            onKeyDown={handleDocumentSearch}
                            readOnly={!!id}
                        />
                        {errors.ruc && <p className="error-message">{errors.ruc}</p>}
                    </div>
                    <div className="basic-info-form-group">
                        <label style={{ color: errors.name ? "red" : "revert-layer" }}>
                            Nombre
                        </label>
                        <input
                            type="text"
                            placeholder="Nombre"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                        {errors.name && <p className="error-message">{errors.name}</p>}
                    </div>
                    <div className="basic-info-form-group">
                        <label style={{ color: errors.description ? "red" : "revert-layer" }}>
                            Descripción
                        </label>
                        <input
                            type="text"
                            placeholder="Descripción"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                        {errors.description && <p className="error-message">{errors.description}</p>}
                    </div>
                    <div className="basic-info-form-group">
                        <label style={{ color: errors.dbName ? "red" : "revert-layer" }}>
                            IP Pública API Fenix
                        </label>
                        <input
                            type="text"
                            placeholder="IP Pública del Servidor"
                            value={uriApiFnx}
                            onChange={(e) => setUriApiFnx(e.target.value)}
                        />
                        {errors.uriApiFnx && <p className="error-message">{errors.uriApiFnx}</p>}
                    </div>
                    <div className="basic-info-form-group">
                        <label>Tipo Conexión</label>
                        <select
                            value={engine}
                            onChange={(e) => setEngine(e.target.value)}
                        >
                            <option value="">Seleccione una opción</option>
                            <option value="mysql">MySQL</option>
                            <option value="vfp">VFoxPro</option>
                        </select>
                    </div>

                    <div className="basic-info-form-group">
                        <label style={{ color: errors.dbName ? "red" : "revert-layer" }}>
                            Nombre de la Base de Datos
                        </label>
                        <input
                            type="text"
                            placeholder=" Nombre de la Base de Datos"
                            value={dbName}
                            onChange={(e) => setDbName(e.target.value)}

                        />
                        {errors.dbName && <p className="error-message">{errors.dbName}</p>}
                    </div>

                    {engine === "mysql" && (
                        <>
                            <div className="basic-info-form-group">
                                <label style={{ color: errors.dbHost ? "red" : "revert-layer" }}>
                                    Host
                                </label>
                                <input
                                    type="text"
                                    placeholder="Host"
                                    value={dbHost}
                                    onChange={(e) => setDbHost(e.target.value)}
                                />
                                {errors.dbHost && <p className="error-message">{errors.dbHost}</p>}
                            </div>
                            <div className="basic-info-form-group">
                                <label style={{ color: errors.dbPort ? "red" : "revert-layer" }}>
                                    Puerto
                                </label>
                                <input
                                    type="text"
                                    placeholder="Puerto"
                                    value={dbPort}
                                    //onChange={(e) => setDbPort(e.target.value)}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (/^\d{0,7}$/.test(value)) {
                                            setDbPort(value);
                                        }
                                    }}
                                />
                                {errors.dbPort && <p className="error-message">{errors.dbPort}</p>}
                            </div>
                            <div className="basic-info-form-group">
                                <label style={{ color: errors.dbUser ? "red" : "revert-layer" }}>
                                    Usuario
                                </label>
                                <input
                                    type="text"
                                    placeholder="Usuario"
                                    value={dbUser}
                                    onChange={(e) => setDbUser(e.target.value)}
                                />
                                {errors.dbUser && <p className="error-message">{errors.dbUser}</p>}
                            </div>
                            <div className="basic-info-form-group">
                                <label style={{ color: errors.dbPass ? "red" : "revert-layer" }}>
                                    Contraseña
                                </label>
                                <input
                                    type="text"
                                    placeholder="Contraseña"
                                    value={dbPass}
                                    onChange={(e) => setDbPass(e.target.value)}
                                />
                                {errors.dbPass && <p className="error-message">{errors.dbPass}</p>}
                            </div>
                        </>
                    )}
                    {id && (
                        <div className="basic-info-form-group">
                            <div className="basic-info-form-switch">
                                <label>Período Cerrado</label>
                                <div className="slider-container-contract" onClick={toggleSwitch}>
                                    <div
                                        className={`slider-option-contract ${isClosed
                                            ? "active-contract"
                                            : "inactive-contract"
                                            }`}
                                    >
                                        Activo
                                    </div>
                                    <div
                                        className={`slider-option-contract ${!isClosed
                                            ? "active-contract"
                                            : "inactive-contract"
                                            }`}
                                    >
                                        Inactivo
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                <div className="basic-form-footer">
                    <button
                        className="basic-custom-button"
                        onClick={(e) => {
                            e.stopPropagation();
                            navigate(-1);
                        }}
                    >
                        <FontAwesomeIcon icon={faXmark} className="basic-shortcut-icon" />
                        Cancelar
                    </button>
                    <button
                        className="basic-custom-button"
                        onClick={handleSave}
                        disabled={isButtonDisabled}
                    >
                        <FontAwesomeIcon
                            icon={id ? faRotate : faSave}
                            className="basic-shortcut-icon"
                        />
                        {id ? "Actualizar" : "Guardar"}
                    </button>
                </div>
            </div>
            <SuccessNotification
                message={
                    id
                        ? "La Compañía se ha Actualizado Correctamente."
                        : "La Compañía se ha Creado Correctamente."
                }
                isVisible={isSuccessVisible}
                onClose={() => setIsSuccessVisible(false)}
            />
            <ErrorNotification
                message={errorsMessage}
                isVisible={isErrorVisible}
                onClose={() => setIsErrorVisible(false)}
            />
            <LoginNotification
                message="Vuelve a iniciar sesión"
                isVisible={isLoginVisible}
                onClose={() => setIsLoginVisible(false)}
                onLogout={handleLogout}
            />
            {loading && <Loader />}
        </div>
    );
};

export default CompaniesForm;
